<ng-template [ngIf]="inserimento">
	<div class="col-sm-12 coldx" 
		[ngStyle]="{ 'display' : ( visibleToggleAssocia ? 'block' : 'none') }">
		<h4 *ngIf="title">{{title}}</h4>
		<form class="cerca_grey">
			<div class="row">
				<p class="col-sm-12">
					<label for="cerca-pagamento-form-lbl">Cerca</label> <input id="cerca-pagamento-form-lbl" type="text" #searchItem (keyup)="0"
						class="form-control" placeholder="Inserisci nome e cognome" />
				</p>
			</div>
		</form>
	<ng-template [ngIf]="beneficiariAll && beneficiariAll.length > 0">
	<ng-template ngFor let-beneficiario [ngForOf]="beneficiariAll  | searchFilter : searchItem.value : 'beneficiarioPagamento.persona.nominativo'">
		<ul id="controparticollapse" class="controparti">
			<li class="panel">
				<div class="controparte">
					<div>
						<p class="col-xs-12 col-sm-2">
							<button class="btn btn-primary associa"
								(click)="setBeneficiario(beneficiario);" type="submit">Associa</button>
						</p>
						<h4 class="titolo col-sm-3">{{ beneficiario.beneficiarioPagamento.persona.nominativo }}</h4>
						<ng-template [ngIf]="beneficiario.beneficiarioPagamento.persona.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
							<p class="col-sm-3">
								C/F: <strong> {{ beneficiario.beneficiarioPagamento.persona.codiceFiscale }} </strong>
							</p>
							<p class="col-sm-2 matricola">
								MAT: <strong>{{beneficiario.beneficiarioPagamento.persona.matricola}}</strong>
							</p>
						</ng-template>
						<ng-template
							[ngIf]="beneficiario.beneficiarioPagamento.persona.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
							<p class="col-sm-3">
								P.IVA: <strong> {{ beneficiario.beneficiarioPagamento.persona.partitaIva }} </strong>
							</p>
						</ng-template>

						<p class="col-sm-2">
							<strong>{{beneficiario.beneficiarioPagamento.categoria ? beneficiario.beneficiarioPagamento.categoria : beneficiario.beneficiarioPagamento.tipoBeneficiarioPagamento.descrizione}}</strong>
						</p>
					</div>
				</div>
			</li>
		</ul>
	</ng-template></ng-template>
	<ng-template [ngIf]="(!beneficiariAll || beneficiariAll.length == 0) && msgNoBeneficiari">
		<p>{{msgNoBeneficiari}}</p>
	</ng-template>
	</div>
</ng-template>

<ng-template [ngIf]="pagamentoForm">
<div class="col-sm-12 coldx" 
	[ngStyle]="{ 'display' : ( visibleToggleForm ? 'block' : 'none') }">
	<h4 *ngIf="title">{{title}}</h4>
	<div class="tab-content">
		<form [formGroup]="pagamentoForm" (ngSubmit)="save();">
			<div class="row">
				<ng-template [ngIf]="!inserimento">

				<div comboModInput class="col-sm-3"
					[labelInput]="'Tipo beneficiario'"
					formControlName="tipoBeneficiario"
					[optionsCombo] ="tipiBeneficiariOptions" [mandatory]="true"
					[control]="pagamentoForm.controls['tipoBeneficiario']"
					(onReturn)="populateBeneficiari($event)"
					[disabledCheck]="true"
					[disabledCheckProperty] ="'rimosso'"
					[objectReference]="tipoBeneficiario"></div>

				<div comboModInput class="col-sm-3" [labelInput]="'Beneficiario'"
					formControlName="beneficiario" [optionsCombo] ="beneficiariOptions"
					[labelOption]="'beneficiarioPagamento.persona.nominativo'" [mandatory]="true"
					[control]="pagamentoForm.controls['beneficiario']"
					[valueOption] ="idParent"
					[objectReference]="beneficiario"
					(onReturn)="setBeneficiarioFromEvent($event)"></div>
				</ng-template>
				<ng-template [ngIf]="inserimento && beneficiarioView && beneficiarioView?.persona.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Cognome e nome'"
					[valueInput]="beneficiarioView?.persona.cognome+' '+beneficiarioView?.persona.nome"></div>

				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Tipo beneficiario'"
					[valueInput]="beneficiarioView?.categoria ? beneficiarioView?.categoria : beneficiarioView?.tipoBeneficiarioPagamento.descrizione"></div>
				</ng-template>
				<ng-template [ngIf]="inserimento && beneficiarioView && beneficiarioView?.persona.tipoPersona.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Ragione sociale'"
					[valueInput]="beneficiarioView?.persona.ragioneSociale"></div>

				<div labelTextInput class="col-sm-3 bloccodati" [typeLabel]="'text'"
					[labelInput]="'Tipo beneficiario'"
					[valueInput]="beneficiarioView?.categoria ? beneficiarioView?.categoria : beneficiarioView?.tipoBeneficiarioPagamento.descrizione"></div>
				</ng-template>
				<div
					textInput [control]="pagamentoForm.controls['numeroAutorizzazione']"
					class="col-sm-3" [labelInput]="'Numero autorizzazione'"
					formControlName="numeroAutorizzazione"
					[(ngModel)]="request.numeroAutorizzazione"></div>
				<div datePickerInput class="col-sm-3"
					[labelInput]="'Data autorizzazione'"
					formControlName="dataAutorizzazione"
					[(ngModel)]="request.dataAutorizzazione"></div>
			</div>
			<div class="row">
				<div datePickerInput class="col-sm-3" [mandatory]="true"
					[control]="pagamentoForm.controls['dataPagamento']"
					[labelInput]="'Data pagamento'" formControlName="dataPagamento"
					[(ngModel)]="request.dataPagamento"></div>
				<div comboModInput class="col-sm-3"
					[labelInput]="'Titolo pagamento'" formControlName="motivo"
					[mandatory]="true" [objectReference]="request.motivo"
					(onReturn)="request.motivo = $event" [ngModel]="request.motivo"
					[optionsCombo] ="motiviPagamentoOptions"
					[control]="pagamentoForm.controls['motivo']"></div>
				<div comboModInput class="col-sm-3" [labelInput]="'Tipo pagamento'"
					formControlName="tipoPagamento" [mandatory]="true"
					[objectReference]="request.tipoPagamento"
					(onReturn)="request.tipoPagamento = $event"
					[optionsCombo] ="tipiPagamentoOptions"
					[ngModel]="request.tipoPagamento"
					[control]="pagamentoForm.controls['tipoPagamento']"></div>
				<div comboModInput class="col-sm-3"
					[labelInput]="'Modalit&agrave; pagamento'"
					formControlName="modalitaPagamento"
					[objectReference]="request.modalitaPagamento"
					(onReturn)="request.modalitaPagamento = $event"
					[optionsCombo] ="modalitaPagamentoOptions"></div>
			</div>
			<!--<div class="row">
				<div comboModInput class="col-sm-6"
					[labelInput]="'Tipo somme liquidate'"
					formControlName="tipoSommaLiquidata"
					[objectReference]="request.tipoSommaLiquidata"
					(onReturn)="request.tipoSommaLiquidata = $event"
					[optionsCombo] ="tipiSommaLiquidataOptions"></div>

				<div comboModInput class="col-sm-6" [labelInput]="'Terzo pignorato'"
					formControlName="terzoPignorato" [labelOption]="'parte.nominativo'"
					[objectReference]="request.terzoPignorato" (onReturn)="request.terzoPignorato = $event"
					[optionsCombo] ="terzoPignoratoOptions"></div>

			</div>-->

			<div class="container_conteggi">

				<div
					*ngFor="let cpaImporto of [( request.importo | percentage : cpaPerc )]">
					<div
						*ngFor="let totImponibile of [( getSum(cpaImporto, request.importo) )]">
						<div
							*ngFor="let ivaImporto of [( totImponibile | percentage : ivaPerc )]">
							<div
								*ngFor="let importoLordo of [( getSum(ivaImporto,totImponibile, request.sommaNonSoggettaRitenuta) )]">
								<div
									*ngFor="let ritenutaAcconto of [( request.flagRitenutaAcconto ? ( request.importo | percentage:20) : 0 )]">

									<div
										textInputCurrency [control]="pagamentoForm.controls['importo']"
										[mandatory]="true" class="" [labelInput]="'Imponibile'"
										formControlName="importo" [(ngModel)]="request.importo"></div>

									<div comboModInput [labelInput]="'Aliquota CPA'"
										(change)="ricalcolaImporti($event,'cpa')"
										formControlName="cpa" [location]="'conteggi'"
										[labelOption]="'valore'" [objectReference]="request.cpa"
										(onReturn)="request.cpa = $event" [optionsCombo] ="cpaOptions"></div>

									<div>
										<p class="col-sm-9 bloccodati">
											<label for="cpa-pagamento-form-lbl">CPA</label>
										</p>
										<p class="col-sm-3">
											<input id="cpa-pagamento-form-lbl" class="alignright form-control" disabled=""
												value="{{cpaImporto | euro}} &euro;" type="text">
										</p>
									</div>

									<div>
										<p class="col-sm-offset-7 col-sm-2 alignright">
											<label for="importo-cpa-pag-form-lbl">Importo + CPA</label>
										</p>
										<p class="col-sm-3">
											<input id="importo-cpa-pag-form-lbl" class="alignright totale form-control" disabled=""
												value="{{totImponibile | euro}} &euro;" type="text">
										</p>
									</div>

									<div comboModInput [labelInput]="'Aliquota Iva'"
										(change)="ricalcolaImporti($event,'iva')"
										formControlName="iva" [location]="'conteggi'"
										[labelOption]="'valore'" [objectReference]="request.iva"
										(onReturn)="request.iva = $event" [optionsCombo] ="ivaOptions"></div>

									<div>
										<p class="col-sm-9 bloccodati">
											<label for="iva-pag-form-lbl">IVA</label>
										</p>
										<p class="col-sm-3">
											<input id="iva-pag-form-lbl" class="alignright form-control" disabled=""
												value="{{ivaImporto | euro}} &euro;" type="text">
										</p>
									</div>
									<div
										textInputCurrency [control]="pagamentoForm.controls['sommaNonSoggettaRitenuta']"
										class="" [labelInput]="'Somma non soggetta a ritenuta'"
										formControlName="sommaNonSoggettaRitenuta"
										[(ngModel)]="request.sommaNonSoggettaRitenuta"></div>
									<div>
										<p class="col-sm-offset-6 col-sm-3 alignright">
											<label for="imp-lordo-lbl">Importo Lordo Complessivo</label>
										</p>
										<p class="col-sm-3">
											<input id="imp-lordo-lbl" class="alignright totale form-control" disabled=""
												value="{{importoLordo | euro}} &euro;" type="text">
										</p>
									</div>
									<!-- <div
										textInputCurrency [control]="pagamentoForm.controls['sommaNonSoggettaRitenuta']"
										class="" [labelInput]="'Somma non soggetta a ritenuta'"
										formControlName="sommaNonSoggettaRitenuta"
										[(ngModel)]="request.sommaNonSoggettaRitenuta"></div> -->

									<div class="">
										<p class="col-xs-9 col-sm-9 bloccodati">
											<label class="fakelabel">Applica ritenuta d'acconto</label>
										</p>
										<p class="col-xs-3 col-sm-3 active singlecheckbox pagamenti">
											<input formControlName="flagRitenutaAcconto"
												id="{{'flagRitenutaAcconto' + inserimento}}" class="alignright form-control"
												[(ngModel)]="request.flagRitenutaAcconto" type="checkbox">
											<label for="{{'flagRitenutaAcconto' + inserimento}}">{{request.flagRitenutaAcconto ? 'Si' : 'No'}}</label>
										</p>
									</div>

									<div *ngIf="request.flagRitenutaAcconto">
										<p class="col-sm-9 bloccodati">
											<label for="rit-acc-lbl">Ritenuta d'acconto</label>
										</p>
										<p class="col-sm-3">
											<input id="rit-acc-lbl" class="alignright form-control" disabled=""
												value="{{ ritenutaAcconto | euro }} &euro;" type="text">
										</p>
									</div>
									<div>
										<p class="col-sm-offset-7 col-sm-2 alignright">
											<label for="netto-lbl">Netto a pagare</label>
										</p>
										<p class="col-sm-3">
											<input id="netto-lbl" class="alignright totale form-control" disabled=""
												value="{{ getDiff(importoLordo,ritenutaAcconto) | euro }} &euro;"
												type="text">
										</p>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

			</div>
			<div class="row">
				<div textAreaInput class="col-xs-12 col-sm-12" [labelInput]="'Note'"
					formControlName="note" [(ngModel)]="request.note"></div>
			</div>
			<div class="row">
				<p class="mandatory col-sm-12">
					<em>* Campi obbligatori</em>
				</p>
			</div>
			<div class="row">
				<p class="col-sm-3 col-xs-6">
					<ng-template [ngIf]="inserimento">
						<button type="button" (click)="goToAssocia();"
							class="btn btn-outline-secondary btn-block">Indietro</button>
					</ng-template>
					<ng-template [ngIf]="!inserimento">
						<button type="button" class="btn btn-outline-secondary btn-block"
							(click)="reset();">Reset</button>
					</ng-template>
				</p>
				<p submitButton [disabled]="!pagamentoForm.valid || (!inserimento && (!tipoBeneficiario || !beneficiario)) || !request || !request.importo || request.importo.toString().trim().length == 0"
					class="col-sm-3 col-xs-6 col-sm-offset-6"
					[labelButton]="'Salva'"></p>
			</div>
		</form>
	</div>
</div>
</ng-template>
